<div class="no-add-ons">
  <h2 class="no-add-ons__title">No add-ons</h2>
  <p data-cy="description" class="no-add-ons__description">
    We did not find any add-ons for you to review. If you need to, you can go
    ahead and register another person—otherwise, you're all set to complete your
    registration.
  </p>
</div>
<app-add-on-footer
  class="no-add-ons__footer"
  (registerAnotherPersonClick)="registerAnother()"
  (continueToCheckoutClick)="checkout()"
  [displayRegisterAndCompleteButtons]="true"></app-add-on-footer>
